export default {
  title: 'Préférences de communication',
  informationsLabel: 'L’abonnement aux services électroniques vous permet de consulter l’information sur vos produits de façon sécuritaire et au moment qui vous convient.',
  documentPreferences: {
    sectionTitle: 'Documents',
    textPart1: 'Plusieurs ',
    textPart2: 'documents sont disponibles en ligne',
    textPart3: ' et d\'autres s\'ajouteront au fur et à mesure de leur disponibilité en format électronique. Les documents qui ne sont pas offerts en ligne vous seront transmis par la poste.',
    option1: 'En ligne',
    option2: 'Par la poste',
  },
  communicationPreference: {
    option1: 'Par courriel',
    option2: 'Par la poste',
    sectionTitle: 'Communications et suivis',
    label: 'Échanges d\'informations et suivis de dossier en lien avec vos contrats',
  },
  subscribeToDocumentNotification: {
    label: 'Notifications par courriel',
    text: 'Je désire recevoir une notification par courriel lorsqu\'un nouveau document est disponible.',
  },
  termsOfUse: {
    textPart1: 'J\'ai lu et j\'accepte ',
    textPart2: 'les modalités et conditions d\'utilisation',
    textPart3: '.',
    modalTitle: 'Modalités et conditions d\'utilisation',
  },
};
